import React from "react";
import { Col } from "reactstrap";
import DashPanel from "../common/DashPanel";
import SectionTitle from "../common/SectionTitle";
import StatBadgeRow from "../common/StatBadgeRow";
import InlineBarChart from "../charts/InlineBarChart";
import { T } from "../../constants/theme";
import { securityData } from "../../data/dashboardMockData";

const SecuritySection = ({ loading }) => (
  <Col xl={5} className="d-flex">
    <DashPanel
      title="Security — Failed Logins"
      icon="bx bx-shield-quarter"
      iconColor={T.red}
      loading={loading}
    >
      <StatBadgeRow
        items={[
          { label: "Today", value: securityData.failedLoginsToday, color: T.red },
          { label: "This Week", value: securityData.failedLoginsThisWeek, color: T.orange },
          { label: "Locked Accts", value: securityData.lockedAccounts, color: T.yellow },
          { label: "Suspect IPs", value: securityData.suspiciousIPs, color: T.purple },
        ]}
        loading={loading}
      />

      <SectionTitle>Recent Failures</SectionTitle>
      <div className="sad-scroll-list sad-scroll-list--sm">
        {securityData.recentFailures.map((f, i) => (
          <div key={i} className="sad-failure-row">
            <div>
              <div style={{ fontSize: "12px", fontWeight: 600, color: T.text }}>{f.user}</div>
              <div style={{ fontSize: "10px", color: T.muted }}>
                {f.ip} · {f.time}
              </div>
            </div>
            <span
              style={{
                flexShrink: 0,
                fontSize: "10px",
                padding: "2px 7px",
                borderRadius: "4px",
                background: "#fde8e8",
                color: T.red,
                fontWeight: 600,
              }}
            >
              {f.reason}
            </span>
          </div>
        ))}
      </div>

      <SectionTitle style={{ marginTop: "14px" }}>Failures by Hour</SectionTitle>
      <InlineBarChart
        data={securityData.failedByHour}
        labelKey="hour"
        valueKey="count"
        color={T.red}
        formatValue={(v) => String(v)}
        loading={loading}
      />
    </DashPanel>
  </Col>
);

export default SecuritySection;
